<template>
    <!-- <div class="mediver-register-container nb find-temp-pw-container"> -->
    <div class="find-temp-pw-container nb">
        <!-- <div class="mediver-login-logo mediver-temp-pw-logo" style="border: 1px solid red;"> -->
        <div class="mediver-temp-pw-logo">
            <!-- <img src="@/assets/resource/icon/hover_logo.png" alt="Electroceuticals" class="login-logo-img" /> -->
            <img src="@/assets/resource/icon/hover_logo.png" alt="Electroceuticals" class="temp-logo-img" />
            <!-- <h2 class="main-title">Electroceuticals</h2> -->
            <div class="sub-title">비밀번호 재설정</div>
        </div>
        <!-- <div class="temp-box"></div> -->
        <!-- <div class="notice-box"> -->
        <div class="temp-box">
            <!-- <div class="notice-header">유의 사항</div>
            <div class="notice-content">영문, 숫자, 특수문자를 조합하여 작성</div>
            <div class="notice-content">특수문자 사용 가능 범위: ~!@#%^&*_-</div> -->
            <div class="temp-header">유의 사항</div>
            <div class="temp-content">영문, 숫자, 특수문자를 조합하여 작성</div>
            <div class="temp-content">특수문자 사용 가능 범위: ~!@#%^&*_-</div>
        </div>
        <!-- <form class="-box" @submit.prevent="resetPassword"> -->
        <form class="temp-register-box" @submit.prevent="resetPassword">
            <div class="register-text">새로운 비밀번호를 입력해주세요.</div>
            <div class="notice-error" v-if="validTempPassword.status">{{ validTempPassword.msg }}</div>
            <input v-model="tempPassword" type="password" class="login-input" placeholder="임시 비밀번호"
                autocomplete="tempPassword" ref="tempPw" @keydown.space.prevent/>
            <br />
            <div class="notice-error" v-if="validNewPassword.status">{{ validNewPassword.msg }}</div>
            <input v-model="password" type="password" class="login-input" placeholder="새로운 비밀번호" autocomplete="password"
                ref="pw" @keydown.space.prevent/>
            <div class="notice-error" v-if="validConfirmPassword.status">{{ validConfirmPassword.msg }}</div>
            <input v-model="validPassword" type="password" class="login-input" placeholder="새로운 비밀번호 확인"
                autocomplete="validPassword" ref="validPw" @keydown.space.prevent/>
            <div class="popup-btn-group">
                <button type="submit" class="blue-btn">재설정 하기</button>
            </div>
            <div class="login-links">
                <span class="link" @click="$emit('toLogin')">로그인 화면</span>
                <span class="divider">|</span>
                <span class="link" @click="$emit('toRegister')">회원가입</span>
                <span class="divider">|</span>
                <span class="link" @click="$emit('toFindId')">아이디 찾기</span>
            </div>
        </form>
    </div>
</template>
<script>
    import api, { urls } from '@/api'
    import { useAppAlert }  from '@/composables/useAppAlert';

    const { showAlert, showAlertAndMove, confirm } = useAppAlert()

    export default {
        name: "Password",
        props: {
            email: ''
        },
        data() {
            return {
                tempPassword: "", // 기존
                password: "", // 새로운
                validPassword: "",
            };
        },
        computed: {
            validTempPassword() {
                return this.createValidation(
                    !this.tempPassword,
                    '* 임시 비밀번호를 입력해주세요.'
                )
            },
            validNewPassword() {
                if (!this.password) {
                    return this.createValidation(true, '* 새로운 비밀번호를 입력해주세요.')
                }

                const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[~!@#%^&*_-])[A-Za-z\d~!@#%^&*_-]{8,}$/
                return this.createValidation(
                    !regex.test(this.password),
                    '* 영문, 숫자, 특수문자를 조합하여 8자 이상으로 작성해주시길 바랍니다.'
                )
            },
            validConfirmPassword() {
                if (!this.validPassword) {
                    return this.createValidation(true, '* 새로운 비밀번호 확인을 입력해주세요.')
                }

                return this.createValidation(
                    this.password !== this.validPassword,
                    '* 새로운 비밀번호가 맞지 않습니다.'
                )
            }
        },
        methods: {
            createValidation(condition, message = '') {
                return {
                    status: !!condition,
                    msg: condition ? message : ''
                }
            },
            async resetPassword() {
                if (!this.tempPassword) {
                    // alert('기존 비밀번호를 입력해주세요.')
                    this.$refs.tempPw.focus()
                    return
                }
                if (!this.password) {
                    // alert('새로운 비밀번호를 입력해주세요.')
                    this.$refs.pw.focus()
                    return
                }
                if (!this.validPassword) {
                    // alert('새로운 비밀번호 확인을 입력해주세요.')
                    this.$refs.validPw.focus()
                    return
                }
                const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[~!@#%^&*_-])[A-Za-z\d~!@#%^&*_-]{8,}$/;
                if (!regex.test(this.password)) {
                    // alert('영문, 숫자, 특수문자를 조합하여 8자 이상으로 작성해주시길 바랍니다.')
                    this.$refs.pw.focus()
                    return
                }
                if (this.password != this.validPassword) {
                    // alert('새로운 비밀번호가 맞지 않습니다.')
                    this.$refs.validPw.focus()
                    return
                }

                api.post(urls.login.resetPassword, {
                    email: this.email,
                    tempPassword: this.tempPassword,
                    password: this.password
                }).then(response => {
                    const res = response.data;

                    if (res.error) {
                        const result = res.error || '임시비밀번호 발급 중 오류가 발생했습니다. 관리자에게 문의해주시길 바랍니다.';
                        showAlert(result)
                    } else {
                        showAlert('비밀번호가 재설정되었으니 다시 로그인해주시길 바랍니다.')
                        this.$emit('status', true)
                    }
                })
                    .catch(err => {
                        showAlert('임시비밀번호 발급 중 오류가 발생했습니다. 관리자에게 문의해주시길 바랍니다.')
                    });
            }
        }
    };
</script>
